import { Inject, Injectable } from "@angular/core";
import { generateVersion4GUID } from "@obg/global.evo";
import { TelemetryService } from "@obg/ngx.global";
import { WindowRef } from "@obg/ngx.global.evo";

import { STARTUP_CONTEXT_TOKEN } from "../../app-context/app-context.const";
import { StartupContext } from "../../app-context/app-context.model";

@Injectable()
export class OpenIdConnectService {
	constructor(
		private windowRef: WindowRef,
		@Inject(STARTUP_CONTEXT_TOKEN) private startupContext: StartupContext,
		private telemetryService: TelemetryService
	) {}

	navigateToOidcBroker(url: string, queryParams?: { [key: string]: string }): void {
		if (!url) {
			return;
		}

		const sessionCorrelationId = this.getUniqueId();
		const languageCode = !this.startupContext.isLanguageCodeInUrlDisabled
			? `/${this.startupContext.market.languageCode}`
			: "";

		const { protocol, host } = this.windowRef.native.location;
		const returnUrl = `${protocol}//${host}${languageCode}/oidc-verify`;

		const queryParamString = queryParams
			? Object.entries(queryParams)
					.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
					.join("&")
					.replace(/^/, "&")
			: "";

		const redirectUrl = `${url}?sessionCorrelationId=${sessionCorrelationId}&returnUrl=${encodeURIComponent(
			returnUrl
		)}${queryParamString}`;

		this.telemetryService.track({ sessionCorrelationId });
		this.windowRef.native.location.href = redirectUrl;
	}

	getUniqueId(): string {
		return generateVersion4GUID();
	}
}
